export default ($options) => Object.assign({
  events: false,
  enableEvents: true, // Boolean
}, $options)